import { render, staticRenderFns } from "./StartForm22.vue?vue&type=template&id=2672a0e2&scoped=true"
import script from "./StartForm22.vue?vue&type=script&lang=ts"
export * from "./StartForm22.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2672a0e2",
  null
  
)

export default component.exports